<template>
  <section class="soft-skills-dynamics">
    <div class="soft-skills-dynamics__header">
      <h2 class="soft-skills-dynamics__title">
        Динамика роста гибких навыков
      </h2>

      <div class="soft-skills-dynamics__filters">
        <a-select
            v-model:value="selectedGroup"
            :options="groupOptions"
            class="soft-skills-dynamics__select"
        />
        <div>
          <a-range-picker
              v-model:value="selectedPeriod"
              :placeholder="['Дата начала', 'Дата конца']"
              format="DD.MM.YYYY"
              value-format="YYYY-MM-DD"
              class="soft-skills-dynamics__date"
          />
        </div>
      </div>
    </div>

    <div class="soft-skills-dynamics__grid">
      <SmallCardWrapper
          name="Динамика роста гибких навыков"
          :helpText="'Динамика роста гибких навыков'"
      >
        <SoftSkillsGrowthCard
            :score="growth.score"
            :change="growth.change"
            :changeLabel="growth.changeLabel"
            :indexes="growth.indexes"
            :chartLabels="growth.chartLabels"
            :chartValues="growth.chartValues"
        />
      </SmallCardWrapper>

      <SmallCardWrapper
          name="Динамика утверждений"
          :helpText="'Динамика утверждений'"
      >
        <AssertionsDynamicsCard
            :items="assertions"
        />
      </SmallCardWrapper>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'
import SmallCardWrapper from '@/components/Widgets/WidgetCard.vue'
import AssertionsDynamicsCard from "@/components/Analytics/AssertionsDynamicsCard.vue";
import SoftSkillsGrowthCard from "@/components/Analytics/SoftSkillsGrowthCard.vue";
import {computed} from "@vue/runtime-core";
import {useStore} from "vuex";

export default {
  name: 'SoftSkillsDynamics',

  components: {
    SoftSkillsGrowthCard,
    AssertionsDynamicsCard,
    SmallCardWrapper,
  },

  setup() {
    const store = useStore();
    const groups = computed(() => store.state.group.groups);

    const selectedPeriod = ref(null)

    const selectedGroup = ref('all')

    const groupOptions = computed(() => {
      return [
        {
          label: 'Все сотрудники',
          value: 'all',
        },
        ...groups.value.map((group) => ({
          label: group.name,
          value: group.id,
        })),
      ]
    });

    const periodOptions = [
      {
        label: 'Февраль 2026',
        value: 'february_2026',
      },
      {
        label: 'Январь 2026',
        value: 'january_2026',
      },
      {
        label: 'Декабрь 2025',
        value: 'december_2025',
      },
    ]

    const growth = ref({
      score: 85.5,
      change: 24,
      changeLabel: 'за неделю',
      indexes: [
        {
          label: 'Индекс вырос',
          value: 10,
        },
        {
          label: 'Индекс на том же уровне',
          value: 32,
        },
        {
          label: 'Индекс снизился',
          value: 3,
        },
      ],
      chartLabels: ['Окт', 'Ноя', 'Дек', 'Янв', 'Фев', 'Мар'],
      chartValues: [0, -15, 8, -18, -4, 34],
    })

    const assertions = ref([
      {
        text: 'Управляю своими эмоциями в сложных ситуациях',
        change: 9,
        users: 10,
      },
      {
        text: 'Лучше справляюсь со сложными ситуациями',
        change: -3,
        users: 32,
      },
      {
        text: 'Общаюсь с коллегами более конструктивно',
        change: 2,
        users: 45,
      },
      {
        text: 'Решаю конфликты и недопонимания быстрее',
        change: 25,
        users: 65,
      },
      {
        text: 'Планирую работу с учетом ресурсов команды',
        change: 10,
        users: 108,
      },
      {
        text: 'Увеличилась эффективность совещаний',
        change: -17,
        users: 88,
      },
      {
        text: 'Решения принимаем быстрее и слаженнее',
        change: -7,
        users: 5,
      },
    ])

    return {
      selectedGroup,
      selectedPeriod,
      groupOptions,
      periodOptions,
      growth,
      assertions,
    }
  },
}
</script>

<style scoped lang="scss">
.soft-skills-dynamics {
  width: 100%;
  text-align: start;
}

.soft-skills-dynamics__header {
  margin-bottom: 20px;
}

.soft-skills-dynamics__title {
  margin: 0 0 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.soft-skills-dynamics__filters {
  display: flex;
  align-items: center;
  gap: 14px;
}

.soft-skills-dynamics__select {
  width: 350px;
}

.soft-skills-dynamics__period {
  width: 200px;
}

.soft-skills-dynamics__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
}

.soft-skills-dynamics__grid :deep(.ant-card-body) {
  padding: 0;
}

.soft-skills-dynamics__grid :deep(.small-card-wrapper__body) {
  align-items: stretch;
}

.soft-skills-dynamics__date {
  width: 200px;
}

@media (max-width: $tablet-breakpoint) {
  .soft-skills-dynamics__grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: $mobile-breakpoint) {
  .soft-skills-dynamics__filters {
    flex-direction: column;
    align-items: stretch;
  }

  .soft-skills-dynamics__select,
  .soft-skills-dynamics__period {
    width: 100%;
  }
}
</style>